var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* This component makes its children a drag target. Example:
 *
 *     <DragTarget onDrop={this.handleDrop}>Drag to me</DragTarget>
 *
 *     ...
 *
 *     handleDrop: function(e) {
 *         this.addImages(e.nativeEvent.dataTransfer.files);
 *     }
 *
 * Now "Drag to me" will be a drag target - when something is dragged over it,
 * the element will become partially transparent as a visual indicator that
 * it's a target.
 */
// TODO(joel) - indicate before the hover is over the target that it's possible
// to drag into the target. This would (I think) require a high level handler -
// like on Perseus itself, waiting for onDragEnter, then passing down the
// event. Sounds like a pain. Possible workaround - create a div covering the
// entire page...
//
// Other extensions:
// * custom styles for global drag and dragOver
// * only respond to certain types of drags (only images for instance)!

var React = require('react');

var DragTarget = React.createClass({
    displayName: "DragTarget",

    propTypes: {
        // All props not listed here are forwarded to the root element without
        // modification.
        onDrop: React.PropTypes.func.isRequired,
        component: React.PropTypes.any, // component type
        shouldDragHighlight: React.PropTypes.func,
        style: React.PropTypes.any
    },
    getDefaultProps: function getDefaultProps() {
        return {
            component: "div",
            shouldDragHighlight: function shouldDragHighlight() {
                return true;
            }
        };
    },
    getInitialState: function getInitialState() {
        return { dragHover: false };
    },
    handleDrop: function handleDrop(e) {
        e.stopPropagation();
        e.preventDefault();
        this.setState({ dragHover: false });
        this.props.onDrop(e);
    },
    handleDragEnd: function handleDragEnd() {
        this.setState({ dragHover: false });
    },
    handleDragOver: function handleDragOver(e) {
        e.preventDefault();
    },
    handleDragLeave: function handleDragLeave() {
        this.setState({ dragHover: false });
    },
    handleDragEnter: function handleDragEnter(e) {
        this.setState({ dragHover: this.props.shouldDragHighlight(e) });
    },
    render: function render() {
        var opacity = this.state.dragHover ? { "opacity": 0.3 } : {};
        var Component = this.props.component;

        var forwardProps = Object.assign({}, this.props);
        delete forwardProps.component;
        delete forwardProps.shouldDragHighlight;

        return React.createElement(Component, _extends({}, forwardProps, {
            style: Object.assign({}, this.props.style, opacity),
            onDrop: this.handleDrop,
            onDragEnd: this.handleDragEnd,
            onDragOver: this.handleDragOver,
            onDragEnter: this.handleDragEnter,
            onDragLeave: this.handleDragLeave
        }));
    }
});

module.exports = DragTarget;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-components/drag-target.jsx
 ** module id = 88
 ** module chunks = 0 2
 **/